import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC } from 'react'

import Box from '@mui/material/Box'

const getStyles = (theme: Theme) => ({
  root: {
    // 5px, so with the row's 5px tile margin and 1px border the avatar sits
    // 11px from the drawer edge — the same column as every other nav icon.
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(1.5),
    height: '30px',
    width: '30px',
    minWidth: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.common.white,
    border: '2px solid #0350A3',
    borderRadius: '50%',
    color: '#0350A3',
    fontSize: '18px',
  },
})

interface Props {
  icon: React.ReactNode
}

export const IconAvatar: FC<Props> = (props) => {
  const { icon } = props
  const styles = getStyles(useTheme())
  return <Box sx={styles.root}>{icon}</Box>
}

IconAvatar.displayName = 'IconAvatar'
